import httpManager from "@/app/shared/utils/httpManager";

export async function fetchFilterValuesByNames(names, base, coverage, product = false) {
  const body = {
    base,
    coverage,
    name_filter: names,
    is_custom_product: product,
  };

  const response = await httpManager.post(
    "/strategies/filters/available-fields-custom/",
    body
  );

  return response.data;
}
